import { Button, Center, Flex, Image, Text } from "@chakra-ui/react";
import Form from "@rjsf/chakra-ui";
import { RJSFSchema, UiSchema } from "@rjsf/utils";
import validator from "@rjsf/validator-ajv8";
import { useState } from "react";

import { LoginLinkConverter } from "@/features/login-link-converter/components/login-link-converter";
import { useLogin } from "@/queries/mutate-login-link";

export const isTestEnvironment = () => window.location.hostname.includes("localhost");

export const schema: RJSFSchema = {
  title: "Inloggen",
  type: "object",
  required: ["email"],
  properties: {
    email: {
      type: "string",
      format: "email",
      title: "E-mail",
    },
  },
};

export const uiSchema: UiSchema = {
  email: {
    "ui:placeholder": "Voer e-mailadres in",
  },
};

export const LOGIN_FORM_WIDTH = "400px";

export function LoginPage() {
  const { mutateAsync: sendLoginLink, isError } = useLogin();
  const [hasBeenSentTo, setHasBeenSentTo] = useState<string | undefined>(undefined);

  return (
    <Center flexDir="column" w="100%" h="100vh">
      <Flex
        gap={8}
        flexDirection="column"
        bg="pipelife_blue.medium"
        w={LOGIN_FORM_WIDTH}
        minHeight="300px"
        alignItems="center"
        sx={{ ".inlog-form": { w: LOGIN_FORM_WIDTH } }}
      >
        <Image alt="klimaatscan logo" h="72px" src="/assets/images/klimaatscan-logo.png" />
        <Form
          className="inlog-form"
          schema={schema}
          onSubmit={async ({ formData }) => {
            const { email } = formData;
            await sendLoginLink(email);
            setHasBeenSentTo(email);
          }}
          uiSchema={{
            ...uiSchema,
            "ui:title": "", // This hides the schema title
          }}
          validator={validator}
        >
          <Button ml="auto" type="submit" variant="primary">
            Verstuur link
          </Button>
        </Form>

        {isError && (
          <Text color="red.500">
            Er is een fout opgetreden bij het versturen van de inloglink. Controleer of de email
            correct is of probeer het later opnieuw.
          </Text>
        )}

        <Text {...(!hasBeenSentTo ? { opacity: 0, pointerEvents: "none" } : {})}>
          Inlog link is verstuurd naar {hasBeenSentTo}. Het kan even duren voordat je de link
          ontvangt en hij kan in je spamfolder terechtkomen.
        </Text>
      </Flex>

      <LoginLinkConverter />
    </Center>
  );
}
